import { useContext } from "react";
import { SchemaContext } from "../context";
export var useWidgetSchema = function () {
    return useContext(SchemaContext);
};
